import * as Yup from "yup"
import { transformSnakeToCamel, transformModelToJson } from "utils/transform"

export const PaginationSchema = Yup.object().shape({
  total: Yup.number().nullable(),
  limit: Yup.number().nullable(),
  page: Yup.number().nullable(),
})

export function jsonToModel(json) {
  try {
    const model = PaginationSchema.cast(json, {
      abortEarly: false,
      stripUnknown: true,
    })
    return model
  } catch (error) {
    throw error
  }
}

export function modelToJson(model) {
  return transformModelToJson(model)
}
